/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020-2022- The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import React, { Component } from "react";
import LandingPage from "../landing/LandingPage.js";
import Sitemap from "../sitemap/Sitemap.js";
import "../nav/NavMain.scss";
import { Application24 } from '@carbon/icons-react';
import { Launch24 } from '@carbon/icons-react';
import MigrateAlt from "@carbon/icons-react/lib/migrate--alt/24";
import { ChevronRight24 } from '@carbon/icons-react';
import { ChevronLeft24 } from '@carbon/icons-react';
import {
  Button,
  PageTitleBar,
  List,
 } from "carbon-addons-iot-react";
import "./ProjectContainer.scss";
import { HierarchyListItemHandler } from "../handlers/HierarchyListItemHandler";
import { ActiveProjectSubMenuItemHandler } from "../handlers/ActiveProjectSubMenuItemHandler";
import { NavButtonClickService } from "../services/NavButtonClickService";
import { CurrentMenuItemPropertyModel } from "./CurrentMenuItemPropertyModel.js"
import { AppMsg, NavConfig } from "../utils/index.js";
import TririgaBreadcrumb from "../breadcrumb/Breadcrumb.js";

var projectContainerHandler;
//Called from project switch dialog on query renderer.
window.findAccept = function (subCatId, projectId) {
  /* eslint eqeqeq: 0 */
  if (projectId == '') {
    return;
  }
  projectContainerHandler.props.switchProject(SUB_CAT_NOT_NECESSARY, projectId, MENU_ITEM_PROJ_HOME);
}

const COMPANY_LEVEL_PROJECT_ID = 1;
const SUB_CAT_NOT_NECESSARY = -1;
const MENU_ITEM_PROJ_HOME = '';
const NOT_FROM_SITEMAP = false;

class ProjectContainer extends Component {

  constructor(props) {
    super(props)
    this.state = {
      currentSelectedMenuItemLabel: '',
      currentSelectedMenuItemId: '',
      isNavPage: false,
      triNavigationSrc: '',
      currentProjectId: 1,
      currentProjectName: '',
      priorProjectId: 1,
      priorProjectName: '',
      sitemapMenuItemsToDisplay: [],
      sitemapMenuItemIdsToDisplay: [],
      projectMenuItems: [],
      showRecentProject: false,
      isShowProjectTitleBar: false,
      expandedProjectMenuIds: [],
      isSubPage: false
    };
    this.projectTitleBarDivRef = React.createRef();
    this.projectSideNavContainerDivRef = React.createRef();
    this.projectDetailsMenuDivRef = React.createRef();
    this.projectSideNavCollapsedDivRef = React.createRef();
    this.landingPageDivRef = React.createRef();
    this.mainPageBreadcrumbRef = React.createRef();
    this.pagetitleBreadcrumbRef = React.createRef();
    this.sitemapDivRef = React.createRef();
    this.sitemapRef = React.createRef();
    this.sitemapMenuItemButtonClick = this.sitemapMenuItemButtonClick.bind(this);
    this.handleListItemHrefReset = this.handleListItemHrefReset.bind(this);
    this.handleNavClickComplete = this.handleNavClickComplete.bind(this);
    this.breadcrumbItemClicked = this.breadcrumbItemClicked.bind(this);
    this.resetQueryProjectSwitcherFunction = this.resetQueryProjectSwitcherFunction.bind(this);
    this.showLandingPage = this.showLandingPage.bind(this);
    this.projectContainerHierarchyListItemHandler = new HierarchyListItemHandler();
    this.navButtonClickService = new NavButtonClickService(this);
    this.isFromNavClick = false;
    this.currentMenuItemPropertyModel = null;
    this.activeProjectSubMenuItemHandler = new ActiveProjectSubMenuItemHandler(this.projectContainerHierarchyListItemHandler);
    this.isUpdateFromProjectSubMenuItemToggle = false;
  }

  componentDidMount() {
    //Set the project container handler
    projectContainerHandler = this;
    //Handle css of PageTitleBar component to align inside components
    this._handlePageTitleBarStyles();
   }

  componentDidUpdate() {
    //Handle active menu item style
    if (this.isUpdateFromProjectSubMenuItemToggle) {
      this.activeProjectSubMenuItemHandler.handle();
      this.isUpdateFromProjectSubMenuItemToggle = false;
    }
  }

  handleProjectState(currentProjectId, currentProjectName, priorProjectId, priorProjectName, showRecentProject) {
    this.setState({
      currentProjectId: currentProjectId,
      currentProjectName: currentProjectName,
      priorProjectId: priorProjectId,
      priorProjectName: priorProjectName,
      showRecentProject: showRecentProject
    });
  }

  handleProjectSubMenuItemTagId(menuItem) {
    menuItem.content.tags = [<div id={this.activeProjectSubMenuItemHandler.generateMenuItemId(menuItem.id)}/>,
                        menuItem.topParentMenuId ? 
                          <div name={this.activeProjectSubMenuItemHandler.generateTopParentMenuItemName(this.activeProjectSubMenuItemHandler.generateMenuItemId(menuItem.topParentMenuId))}/>: 
                        null];
  }

  handleProjectMenuItemsState(projectMenuItems) {
    this.setState({
      projectMenuItems: projectMenuItems,
      isShowProjectTitleBar: true
    });
  }

  handleShowRecentProjectLinkState(showRecentProject) {
    this.setState({
      showRecentProject: showRecentProject
    });
  }

  handleShowProjectTitleBarState(isShowProjectTitleBar) {
    this.setState({
      isShowProjectTitleBar: isShowProjectTitleBar
    });
  }

  selectProjectMenuItem(id, isFromBrowserAction) {
    if (id) {
      //Check if navigation canceled for unsaved data.
      if (this.props.unsavedDataService.isDataSaveNeeded(this.projectContainerHierarchyListItemHandler.handleValidMenuItem(id))) {
        return;
      }
      //Handle active menu item style
      this.activeProjectSubMenuItemHandler.handle(id);
      this.navButtonClickService.selectProjectMenuItem(id, isFromBrowserAction);
    }
  }

  _toggleProjectMenuItem(id) {
    if (this.state.expandedProjectMenuIds.filter(rowId => rowId === id).length > 0) {
      this.setState({
        expandedProjectMenuIds: this.state.expandedProjectMenuIds.filter(rowId => rowId !== id)
      });
    } else {
      this.setState({
        expandedProjectMenuIds: this.state.expandedProjectMenuIds.concat([id])
      });
    }
    this.isUpdateFromProjectSubMenuItemToggle = true;
  }

  sitemapMenuItemButtonClick(menuId) {
    if (this.isCurrentProjectAtProjectLevelContext()) {
      //Handle active menu item style
      this.activeProjectSubMenuItemHandler.handle(menuId);
      this.navButtonClick(menuId, this.projectContainerHierarchyListItemHandler);
    } else {
      this.props.sitemapMenuItemButtonClick(menuId);
    }
  }

  handleListItemHrefReset(menuId, isFromSitemap) {
      //Reset current nav target href to assist with browser right open new window / new tab.
      //This ensures normal menu clicks do not trigger nav calls twice due to item having both onclick code and href url.
      let isProjectContext = this.isProjectLevelContext(this.state.currentProjectId);
      let hierarchyListItemHandler = isProjectContext ? 
            this.projectContainerHierarchyListItemHandler: this.props.hierarchyListItemHandler;
      let listItem = hierarchyListItemHandler.getListItemById(menuId);

      //Query select for element
      let listItemElement;
      if (isProjectContext) {
        //In project context sitemap and sub-menu items share ids since they use the same hierarcyListItemHandler.
        if (isFromSitemap) {
          listItemElement = document.querySelector(".sitemapDiv #"+listItem.hrefId);
        } else {
          listItemElement = document.querySelector("#projectDetailsMenu #"+listItem.hrefId);
        } 
      } else {
        listItemElement = document.querySelector("#"+listItem.hrefId);
      }
      window.currentNavTarget = listItemElement;
      listItemElement.href="javascript:resetNavUrl('"+ listItemElement.href+"')";
  }

  breadcrumbItemClicked(menuItemId, event){
    this.props.sitemapMenuItemButtonClick(menuItemId, event);
  }

  navButtonClick(menuId, hierarchyListItemHandler, isFromBrowserAction) {
    this.navButtonClickService.navButtonClick(menuId, hierarchyListItemHandler, isFromBrowserAction);
  }

  handleNavButtonClickState(menuItem, triNavigationSrc, sitemapMenuItemsToDisplay, sitemapMenuItemIdsToDisplay, isFromBrowserAction, urlHashPart, isInLineUXApp) {
    if (!menuItem.isNavPage) {
      //If on nav page/sitemap style page, nav click boolean should remain false.
      this.isFromNavClick = true; 
      //Handle current menu property model.
      this.currentMenuItemPropertyModel = new CurrentMenuItemPropertyModel(urlHashPart, 
            isFromBrowserAction, 
            menuItem.isOpenInNewWindow, 
            isInLineUXApp);
    } else {
      //Show nav page / siteMap
      this.showSiteMap();
    }
    this.setState({
      currentSelectedMenuItemLabel: menuItem.label,
      triNavigationSrc: triNavigationSrc,
      sitemapMenuItemsToDisplay: sitemapMenuItemsToDisplay,
      sitemapMenuItemIdsToDisplay: sitemapMenuItemIdsToDisplay,
      isNavPage: menuItem.isNavPage,
      isSubPage: false
    });

    //If we are opening in new window we should not update current menu item.
    // Otherwise incorrect breadcrumbs and active menu get displayed for the current page.
    if (!menuItem.isOpenInNewWindow) {
      this.handleCurrentSelectedMenuItemIdNotSubPage(menuItem.id);
    }
  }

  handleCurrentSelectedMenuItemIdForSubPage(menuItemId) {
    if (menuItemId) {
      this.setState({
        currentSelectedMenuItemId :menuItemId,
        isSubPage: true
      });
    }
  }

  handleCurrentSelectedMenuItemIdNotSubPage(menuItemId) {
    if (menuItemId) {
      this.setState({
        currentSelectedMenuItemId :menuItemId,
        isSubPage: false
      });
    }
  }

  handleNavFrameSourceForSubPage(menuItemUrl, menuItemName, isSubPageBookmark, isFromBrowserAction, currentSelectedMenuItemId) {
    //Validate we are in project context, if we are not coming from sub page bookmark.
    if (!isSubPageBookmark) {
      if (this.isCurrentProjectAtProjectLevelContext()) {
        menuItemUrl = menuItemUrl + '&project=' + this.state.currentProjectId;
        
        //If not coming from a bookmark, handle active item logic here.
        if (!isSubPageBookmark) {
          let menuItem = this.projectContainerHierarchyListItemHandler.handleValidMenuItem(this.projectContainerHierarchyListItemHandler.getListItemIdByName(menuItemName));
          this.activeProjectSubMenuItemHandler.handle(menuItem.id);
        }
      }
    }
    //Handle sub page current item
    this.handleCurrentSelectedMenuItemIdForSubPage(currentSelectedMenuItemId);

    //Is from nav click flag. Used by landing page to determine if update is needed.
    this.isFromNavClick = true;
    //Handle hash part
    let urlHashPart = '#';
    if (menuItemUrl.includes('#')) {
      urlHashPart = urlHashPart + menuItemUrl.split('#')[1];
    }
    //Handle current menu property model.
    this.currentMenuItemPropertyModel = new CurrentMenuItemPropertyModel(urlHashPart, isFromBrowserAction);
    this.setState({
      isNavPage: false, //Set isNavPage boolean to false, as this will not be a siteMap style page.
      triNavigationSrc: this.props.tririgaContextUrl + menuItemUrl
    });
  }

  handleNavClickComplete(triNavFrame) {
    //Production mode handle landing page visibility on triNavigation frame events.
    if (process.env.NODE_ENV==='development') {
      this.showLandingPage();
    } else {
      //Dispatch enhanced navigate event
      this.dispatchEnhancedNavigateEvent(triNavFrame, 'triEnhancedNavigateEvent', triNavFrame.contentWindow.location.hash);
    }
    //Reset the nav click boolean, and the current menu item property model.
    this.isFromNavClick = false;
    this.currentMenuItemPropertyModel = null;
  }

  dispatchEnhancedNavigateEvent(triNavFrame, navigateEvent, url) {
    let triEnhancedNavigateEvent = new CustomEvent(navigateEvent,{	
      bubbles: true, 
      composed: true,
      detail:{
        url: url
      }
    });

    //Since enhanced nav is using mainpagepopout.jsp, there is navigation logic that needs to 
    // remain in sync with GWT History state handling due to gwt sub-links. 
    // GWT listens for the triEnhancedNavigateEvent to handle this.
    triNavFrame.contentWindow.dispatchEvent(triEnhancedNavigateEvent);   
  }

  resetQueryProjectSwitcherFunction(triNavFrame) {
    if (process.env.NODE_ENV === 'development') {
      //Just return if development mode. Frame content window changes not supported in development mode.
      return;
    }

    if (triNavFrame.contentWindow && !triNavFrame.contentWindow.changeProject) {
      triNavFrame.contentWindow.changeProject = function (projectId) {
        this.props.switchProject(SUB_CAT_NOT_NECESSARY, projectId, MENU_ITEM_PROJ_HOME);
      }.bind(this);
    }
  }

  _openProjectRecord(projectId) {
    const url = this.props.tririgaContextUrl + '/WebProcess.srv?objectId=750000&actionId=750011&specId=' + projectId;
    window.open(url, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes");
  }

  _openCapitalProjects() {
    const url = this.props.tririgaContextUrl + '/html/en/default/reportTemplate/viewPageReport.jsp?reportTemplId='
      + NavConfig.getNavConfigData().projectPickerQueryId +
      '&selectType=single&manager=1&projectSearch=1&parentSOSubCategoryId=2&showAdd=0';
    window.open(url, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes");
  }

  _switchToRecentProject = (projectId) => {
    console.log('Switch To recent Project')
    this.props.switchProject(SUB_CAT_NOT_NECESSARY, projectId, MENU_ITEM_PROJ_HOME);
  }

  isCurrentProjectAtProjectLevelContext() {
    return this.isProjectLevelContext(this.state.currentProjectId);
  }

  isProjectLevelContext(projectId) {
    return projectId > COMPANY_LEVEL_PROJECT_ID;
  }

  _expandProjectSideNav() {
    this.projectDetailsMenuDivRef.current.classList.add("show");
    this.projectSideNavCollapsedDivRef.current.style.display = "none";
  }

  _collapseProjectSideNav() {
    this.projectDetailsMenuDivRef.current.classList.remove("show");
    this.projectSideNavCollapsedDivRef.current.style.display = "block";
  }

  _handleProjectTitleBarDisplayStyle() {
    if (this.state.isShowProjectTitleBar) {
      return '';
    }
    return 'none';
  }

  _handleProjectSideNavContainerDisplayStyle() {
    if (this.isCurrentProjectAtProjectLevelContext()) {
      return 'flex';
    }
    return 'none';
  }

  //Adding css class which changes the landing page behaviour below medium Breakpoint.
  _mediumBreakpointFunction() {
    if (this._handleProjectSideNavContainerDisplayStyle() === 'flex') {
      return (NavConfig.getNavConfigData().isRTL) ? 'project-landingpage-rtl' : 'project-landingpage';
    }
    else {
      return '';
    }
  }

  _handleSitemapDisplayStyle() {
    if (this.state.isNavPage) {
      return 'flex';
    }
    return 'none';
  }

  showLandingPage() {
    this.landingPageDivRef.current.style.display = 'flex';
  }

  showSiteMap() {
    this.sitemapDivRef.current.style.display = 'flex';
  }

  hideLandingPageAndSitemap() {
    this.hideLandingPage();
    this.sitemapDivRef.current.style.display = 'none';
  }

  hideLandingPage() {
    this.landingPageDivRef.current.style.display = 'none';
  }

  _handleMainPageBreadcrumbCss(property){
    if(property === "paddingLeft"){
      return (this.state.isNavPage)? '12px':'20px';
    }
    if(property === "height"){
      return (this.state.isNavPage)? '17.27px':'25.27px';
    }
    if(property === "paddingBottom"){
      return (this.state.isNavPage)?'0px':'8px';
    }
  }

  _handlepagetitleBreadcrumbCSS(){
    return (this.isCurrentProjectAtProjectLevelContext())? "none":"inline-flex";
  }

  _handlePageTitleBarStyles() {
    if (!document.getElementsByClassName("page-title-bar-header")[0]) {
      return;
    }
    if (this.isCurrentProjectAtProjectLevelContext()) {
      document.getElementsByClassName("page-title-bar-header")[0].childNodes[2].style.flex = 'auto';  //Need this in project mode.
      document.getElementsByClassName("page-title-bar-header")[0].style.display = 'flex';
    } else  {
      document.getElementsByClassName("page-title-bar-header")[0].childNodes[1].style.flex = '';
      document.getElementsByClassName("page-title-bar-header")[0].style.display = 'block';
    }
  }

  render() {
    this._handlePageTitleBarStyles();
    let projectMainHeight = (this._handleProjectTitleBarDisplayStyle() === 'none') ? '100%' : '89.7%';
    let projectTitleBarClassName = NavConfig.getNavConfigData().isCompanyLevelAccessAllowed ? 'projects-switch-page-title' : 'projects-switch-page-title-no-company-access';
    projectTitleBarClassName = NavConfig.getNavConfigData().isRTL ? projectTitleBarClassName + '-rtl' : projectTitleBarClassName;
    projectTitleBarClassName = this.isCurrentProjectAtProjectLevelContext() ? projectTitleBarClassName + " projects-switch-page-title-in-project-context": projectTitleBarClassName;
    let projectSideNavContainerCSS = NavConfig.getNavConfigData().isRTL ? 'projectSideNavContainer-rtl' : 'projectSideNavContainer';
    let projectSwitchContainerClassName = this.isCurrentProjectAtProjectLevelContext() ? 'projectSwitchProjectContextContainer' : 'projectSwitchContainer';
    let breadcrumbWithProjectContainerClassName = this.isCurrentProjectAtProjectLevelContext() ? "noBreadcrumbWithProjectContainer" : "breadcrumbWithProjectContainer";
    return (
      <div style={{ height: 'inherit', paddingLeft: NavConfig.getNavConfigData().isRTL ? '32px' : '16px', paddingRight: NavConfig.getNavConfigData().isRTL ? '16px' : '32px', paddingTop: this.state.isShowProjectTitleBar ? '0px' : '16px' }}>
        <div ref={this.projectTitleBarDivRef} style={{ display: this._handleProjectTitleBarDisplayStyle() }}>
          <PageTitleBar
            className={projectTitleBarClassName}
            collapsed={false}
            content={undefined}
            description={null}
            editable={false}
            extraContent={
              <>
              <div className={breadcrumbWithProjectContainerClassName}>
              
                {/*  To display Recent project Start */}
                <div 
                  className={projectSwitchContainerClassName}
                >
                {this.state.showRecentProject ?
                  <span>
                    <span>
                      {AppMsg.getMessage(AppMsg.PROJ_RECENT)}
                    </span>
                    <span className='recentProjectButton'>
                      <Button renderIcon={MigrateAlt}
                        kind="ghost"
                        onClick={() => { this._switchToRecentProject(this.state.priorProjectId) }}
                      >
                        <div className="recentProjectButtonText">{this.state.priorProjectName}</div>
                      </Button>
                    </span>
                  </span>
                  : null}
                {/*  To display Recent project End */}
                {this.isCurrentProjectAtProjectLevelContext() ?
                  <div className="openProjectRecord">
                    <Button renderIcon={Launch24}
                      kind="ghost"
                      onClick={() => { this._openProjectRecord(this.state.currentProjectId) }}
                    >
                      {AppMsg.getMessage(AppMsg.PROJ_RECORD)}
                    </Button>
                  </div>
                  : null} {/*openProjectRecord*/}
                <div className="projectActionsContainer">
                  <Button renderIcon={Application24}
                    kind="ghost"
                    onClick={() => { this._openCapitalProjects() }}
                  >
                    {this.isProjectLevelContext(this.state.currentProjectId) ? 
                            AppMsg.getMessage(AppMsg.PROJ_SWITCH):
                            AppMsg.getMessage(AppMsg.PROJ_SELECT)
                    }
                  </Button>
                </div> {/*projectActionsContainer*/}
                </div>

                <div className="pagetitlebar-breadcrumb" ref={this.pagetitleBreadcrumbRef}>
                  {(this.state.isShowProjectTitleBar && !this.isCurrentProjectAtProjectLevelContext()) ?
                    <TririgaBreadcrumb
                      menuitems={this.props.menuItems}
                      currentSelectedMenuItemId={this.state.currentSelectedMenuItemId}
                      inPageTitleBar={false}
                      breadcrumbItemClicked={this.breadcrumbItemClicked}
                      isSubPage={this.state.isSubPage}
                      tririgaContextUrl={this.props.tririgaContextUrl}
                    />
                  :null}
                </div>
                
                </div>
              </>
            }
            isLoading={false}
            onEdit={null}
            tabs={undefined}
            title={this.state.currentProjectName}
          />
        </div>

        <main className="app" style={{ height: projectMainHeight }}>
          <section className="main">
            {
              <div style={{ height: 'inherit' }}>
                <div className={projectSideNavContainerCSS}
                  ref={this.projectSideNavContainerDivRef}
                  //Subtracted 105 to stop the project side nav to move below screen size
                  style={{ minHeight: document.body.clientHeight - 105, height: '100%', display: this._handleProjectSideNavContainerDisplayStyle() }}>

                  <div id="projectSideNavCollapsed" ref={this.projectSideNavCollapsedDivRef} className="project-side-nav-menu-collapsed" onClick={() => { this._expandProjectSideNav() }}>
                    <Button
                      renderIcon={NavConfig.getNavConfigData().isRTL ? ChevronLeft24 : ChevronRight24}
                      iconDescription={AppMsg.getMessage(AppMsg.PROJ_MENU)}
                      aria-expanded={false}
                      hasIconOnly
                      kind="ghost"
                      className="project-panel-expand"
                      onClick={() => { this._expandProjectSideNav() }}
                      size="default"
                      tooltipAlignment="center"
                      tooltipPosition={NavConfig.getNavConfigData().isRTL ? 'left' : 'right'}
                    >
                    </Button>
                  </div>
                  <div id="projectDetailsMenu" ref={this.projectDetailsMenuDivRef} className="project-side-nav-menu">
                    <List
                      buttons={[                    
                          <Button
                          renderIcon={NavConfig.getNavConfigData().isRTL ? ChevronRight24 : ChevronLeft24}
                          iconDescription={AppMsg.getMessage(AppMsg.PROJ_MENU)}
                          aria-expanded={true}
                          hasIconOnly
                          kind="ghost"
                          className="project-panel-expand"
                          onClick={() => { this._collapseProjectSideNav() }}
                          size="default"
                          tooltipAlignment="center"
                          tooltipPosition={NavConfig.getNavConfigData().isRTL ? 'left' : 'right'}
                        >
                        </Button>
                      ]
                    }
                      hasMultiSelect={false}
                      hasPagination={false}
                      hasSearch
                      i18n={{
                        close: AppMsg.getMessage("EXPAND"),
                        expand: AppMsg.getMessage("CLOSE"),
                        searchPlaceHolderText: AppMsg.getMessage(AppMsg.PROJ_SEARCH)
                      }}
                      isFullHeight={false}
                      isLoading={false}
                      items={this.state.projectMenuItems}
                      handleSelect={(id) => { 
                        //First reset href to assist with browser open in new window / new tab.
                        this.handleListItemHrefReset(id, NOT_FROM_SITEMAP);
                        this.selectProjectMenuItem(id) 
                      }}
                      title={AppMsg.getMessage(AppMsg.PROJ_DETAILS)}
                      expandedIds={this.state.expandedProjectMenuIds}
                      toggleExpansion={(id) => {
                        this._toggleProjectMenuItem(id);
                      }}
                    />
                  </div>
                </div>
                {/*Main landing page */}
                <div style={{ height: 'inherit' }}>
                    {(!this.state.isShowProjectTitleBar) ?
                     <div ref={this.mainPageBreadcrumbRef} className="breadcrumb-container" style={{paddingLeft:this._handleMainPageBreadcrumbCss("paddingLeft"),height:this._handleMainPageBreadcrumbCss("height"),paddingBottom:this._handleMainPageBreadcrumbCss("paddingBottom")}}>
                        <TririgaBreadcrumb
                          menuitems={this.props.menuItems}
                          currentSelectedMenuItemId={this.state.currentSelectedMenuItemId}
                          breadcrumbItemClicked={this.breadcrumbItemClicked}
                          isSubPage={this.state.isSubPage}
                          tririgaContextUrl={this.props.tririgaContextUrl}
                        />
                     </div>:null}
                     
                    <div ref={this.landingPageDivRef} className={this._mediumBreakpointFunction()} style={{ height:"94.5%" }}>
                      <LandingPage
                        resetQueryProjectSwitcherFunction={this.resetQueryProjectSwitcherFunction}
                        triNavigationSrc={this.state.triNavigationSrc}
                        isFromNavClick={this.isFromNavClick}
                        currentMenuItemPropertyModel={this.currentMenuItemPropertyModel}
                        handleNavClickComplete={this.handleNavClickComplete}
                        // To change the size of Landing Page for Company Level
                        isCompanyLevelAccessAllowedStyle={this._handleProjectSideNavContainerDisplayStyle()}
                        isShowProjectTitleBar={this.state.isShowProjectTitleBar}
                        isRTL={NavConfig.getNavConfigData().isRTL}
                        showLandingPage={this.showLandingPage}
                        navRoutingHandler={this.props.navRoutingHandler}
                      />
                    </div>
                    <div ref={this.sitemapDivRef} className="sitemapDiv" style={{ display: this._handleSitemapDisplayStyle(), height: '96%'  }}>
                      <Sitemap ref={this.sitemapRef}
                        {...this.state}
                        sitemapMenuItemButtonClick={this.sitemapMenuItemButtonClick}
                        handleListItemHrefReset={this.handleListItemHrefReset}
                      />
                    </div>
                  </div>
                </div>
            }
          </section>
        </main>
      </div>
    );
  }
}

export default ProjectContainer;

